module.exports = __webpack_public_path__ + "static/media/gv.32a2b2ee.png";